import React, { useEffect, useState } from 'react'
import MyButton from '../../../UI/form/MyButton'
import { useDispatch, useSelector } from 'react-redux'
import { setScannerActivate, setScannerOpen, setScannerResult } from '../../../../store/scannerSlice'
import ScannerQR from '../../../scanner/ScannerQR'
import ScannerWrap from '../../../scanner/ScannerWrap'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import MySpiner from '../../../UI/spiner/MySpiner'
import { getGoodBySeriesAPI } from '../../../../api/pack/seriesAPI'
import ResultMainSeries from './result/ResultMainSeries'

const ReadMainSeries = ({ goodData, setGoodData, reset, setReset, errorMain, setErrorMain }) => {

    const [scanResultTemp, setScanResultTemp] = useState('')
    // const [goodData, setGoodData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    // const [reset, setReset] = useState(false)

    useEffect(() => {
        if (scanResultTemp) {
            getGoodBySeries()
        }
    }, [scanResultTemp])

    useEffect(() => {
        if (reset) { // Якщо треба скинути
            setScanResultTemp('')
            setError('')
        }
    }, [reset])

    const getGoodBySeries = () => {
        setError('')
        setLoading(true)
        getGoodBySeriesAPI({ 
            goodSeries: scanResultTemp 
            // goodSeries: 'SXO-10-25001-006' 
        }).then(data => {
            setGoodData(data)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setErrorMain(responseError(e))
            setLoading(false)
        })
    }

    // const reset = () => {
    //     setScanResultTemp('')
    //     setGoodData(null)
    // }

  return (
    <div className='seriesRead'>
        <h4>1. Зчитати QR-код наявного товару в коробці</h4>

        <ScannerWrap 
            setResultText={setScanResultTemp}
            reset={reset}
            setReset={setReset}
        />

        {/* <button 
            onClick={() => {
                if (window.QRInterface) {
                    window.QRInterface.postMessage("startScan");
                }
            }}
        >
            Сканувати
        </button> */}

        {
            scanResultTemp ? 
                <div className='success'>
                    Результат сканування: {scanResultTemp}
                </div>
            : ''
        }

        {
            goodData ?
                <>
                    <ResultMainSeries 
                        goodData={goodData}
                    />
                </>
            : ''
        }

        {
            loading ? <MySpiner /> : ''
        }

        {
            error ? 
                <div className='error'>
                    {error}
                </div>
            : ''
        }

    </div>
  )
}

export default ReadMainSeries